window.anchorScroll = function (id) {
  $('html,body').animate({scrollTop: $(id).offset().top - 90}, 'slow')
}

window.viewAll = function (e) {
  let list = $(e.target).closest('[data-role="list"]')
  list.find('.action_item:hidden').show()
  $(e.target).remove()
}
